import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const GettingThere = ({
    className,
    facility,
    rate,
    isMonthly,
    sectionTitle
}) => {
    const classes = classNames(
        'GettingThere',
        className
    );
    const title = (sectionTitle) ? sectionTitle : facility.title;
    const copy = (isMonthly && rate && rate.getting_here)
        ? rate.getting_here.replace(/\\r?\n/g, '<br>')
        : facility.getting_here.replace(/\\r?\n/g, '<br>');

    return (
        <div className={classes}>
            <h3 className="title">{title}</h3>
            <p dangerouslySetInnerHTML={{__html: copy}} />
        </div>
    );
};

GettingThere.propTypes = {
    className: PropTypes.string,
    facility: PropTypes.object.isRequired,
    rate: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]).isRequired,
    isMonthly: PropTypes.bool.isRequired,
    /** An optional title to set the section to. If none is set, the facility title is used. */
    sectionTitle: PropTypes.string
};

export default GettingThere;
